import { Box, Switch, TextField, Typography } from "@mui/material";

const glassCard = { p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", border: "1px solid rgba(229,231,235,0.6)", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" };

const EmailTab = ({ errorMessage, setErrorMessage, skipOption, setSkipOption, validations, setValidations }) => {
  const strictValidation = validations?.strictEmail ?? true;

  return (
    <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Skip Option</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Allow visitors to skip this question</Typography>
          </Box>
          <Switch checked={skipOption} onChange={(e) => setSkipOption(e.target.checked)} size="small" />
        </Box>
      </Box>

      <Box sx={{ ...glassCard, bgcolor: strictValidation ? "rgba(239,246,255,0.8)" : "rgba(255,255,255,0.7)", border: strictValidation ? "1px solid #bfdbfe" : "1px solid rgba(229,231,235,0.6)" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Strict Validation</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Block disposable/temporary emails</Typography>
          </Box>
          <Switch checked={strictValidation} onChange={(e) => setValidations({ ...validations, strictEmail: e.target.checked })} size="small" color="primary" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Error Message</Typography>
        <TextField fullWidth placeholder="Please enter a valid email address" value={errorMessage} size="small"
          onChange={(e) => setErrorMessage(e.target.value)}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
      </Box>
    </Box>
  );
};

export default EmailTab;
